module.exports = __webpack_public_path__ + "img/05_garnish star FOR LANDSCAPE.78f32183.png";